/*
=================
DJA Panzoom v2.51
=================

##Changelog

v2.51 - 01-05-2023

* exposed selector variable
* improved fitRect padding function. now proper screen sized padding either a number or object: top right bottom left.
* added updatePositionOnResize - boolean true/false, default true - whether to update position of element when parent is resized, so it keeps track of center
* added updatePositionOnResizeDebounce - integer, default 0 - whether to debounce (in milliseconds) or run per resize event. useful for performance issues, default 0 runs smooth, anything else gets a little choppy visually.
* added double-right-click to zoom out

v2.5 - 14-12-2022

* added panBy and smoothPanBy functions to move map by x y increment.

v2.4 - 10-11-2022

* Mouse up and touch up set back to document again for when dragging off the canvas.
* create and destroy move events on mouse/touch down/up instead of persistent move events
* added fitElement / smoothFitElement functions
* Added dev feature to only allow two finger panning so single touch can scroll (TODO: fix for desktop)
* Improved end of transition when there's a glitch. now updates again when reaching end.
* Slightly better zoom increment matching in and out - still off though (if you zoom in, then zoom out, should be back where you were, but it's out)
* Added smoothPanToElement / panToElement to pan to an elements position
* Added fixedScaleMin and fixedScaleMax so you can limit the effect of the scale of the .fixed-scale elements
* Added click modifier to bypass clicks so that clicking, dragging then releasing isn't a click
* Fix if options not specified!
* Added prevent right click handler with option to enable disable
* Added getDistanceTo helper function - returns absolute and relative distance to a point on the map
* Added rectPadding helper function - returns a rect with padding applied.
* Added is-transitioning class to wrapper when transitioning
* Added is-following class to wrapper when following
* useShiftKey setting exposed

v2.3 - 02-11-2022

* Added scaling to inertia function so it's separate to drag inertia
* Allowed dragging while pinch zooming
* Optimised inertia bounds function
* Fixed touch/page scrolling issues
* Fixed issue when pinching and removing one finger.

v2.2 - 01-11-2022

* Fixed the pinch zoom offset issue when scrolled down page

*/

/*! Panzoom 2.51, Copyright 2023, Dave Allcott, All rights reserved. */

function Panzoom(selector,options){
	// var options = {};
	if(typeof options=='undefined') options = {};

	var _this = this;

	//multitouch simulator - may affect some buttons, overlays, states etc.
	// !function(a){var b=a.createElement("script");b.onload=function(){TouchEmulator()},b.src="https://cdn.rawgit.com/hammerjs/touchemulator/master/touch-emulator.js",a.body.appendChild(b)}(document);

	// quick and dirty throttle function, single use only!
	var throttled = false; function throttle(callback, delay) {if(!throttled) {callback(); setTimeout(function(){throttled = false; }, delay); throttled = true; } }

	// var element = document.getElementById('panzoom');
	var element = document.querySelectorAll(selector)[0];
	if(element==null) {
		console.warn('Panzoom: Element not found');
		return false;
	}
	var parent = element.parentNode;
	var fixedScaleChildren = element.querySelectorAll('.fixed-scale');
	// var fixedScaleChildren = element.querySelectorAll("[class*='fixed-scale']");

	// options and defaults
	_this.scale = options.startScale ? options.startScale : 1;
	var minScale = options.minScale ? options.minScale : 0.00001;
	var maxScale = options.maxScale ? options.maxScale : 99999;
	var fixedScaleMin = options.fixedScaleMin ? options.fixedScaleMin : 0.00001;
	var fixedScaleMax = options.fixedScaleMax ? options.fixedScaleMax : 99999;
	var wheel_step = options.wheel_step ? options.wheel_step : 0.7;
	var doubleClickZoom = options.doubleClickZoom==false ? options.doubleClickZoom : true;
	var doubleClickZoomFitChildren = options.doubleClickZoomFitChildren ? options.doubleClickZoomFitChildren : false;
	var doubleClickTime = options.doubleClickTime ? options.doubleClickTime : 250;
	var transitionDuration = options.transitionDuration ? options.transitionDuration : 1000;
	var bound = (['contain','cover','inner','none'].includes(options.bound)) ? options.bound : 'inner';
	var innerPadding = options.innerPadding ? options.innerPadding : 20;
	var inertia = options.inertia !== false; // Default: true
	var inertiaFriction = options.inertiaFriction ? options.inertiaFriction : 0.75;
	var scaleInertiaFriction = options.scaleInertiaFriction ? options.scaleInertiaFriction : 0.85;
	var inertiaBounce = options.inertiaBounce ? options.inertiaBounce : 0.2;
	_this.useShiftKey = options.useShiftKey==false ? options.useShiftKey : true;
	var useShiftKeyCallbackThrottle = options.useShiftKeyCallbackThrottle ? options.useShiftKeyCallbackThrottle : 5000;
	var restrictClickToParent = options.restrictClickToParent ? options.restrictClickToParent : false;
	var debug = options.debug ? options.debug : false;
	var dragWhilePinchZooming = options.dragWhilePinchZooming ? options.dragWhilePinchZooming : true;
	var preventSingleTouchDragging = options.preventSingleTouchDragging ? options.preventSingleTouchDragging : false;
	var clickSelector = options.clickSelector ? options.clickSelector : false;
	var preventRightClick = options.preventRightClick ? options.preventRightClick : true;
	var updatePositionOnResize = options.updatePositionOnResize ? options.updatePositionOnResize : true;
	var updatePositionOnResizeDebounce = options.updatePositionOnResizeDebounce ? options.updatePositionOnResizeDebounce : 0;

	if(preventSingleTouchDragging){
		parent.classList.add('requiretwofingerdragging');
	}

	var smoothFollowAnimationFrame, smoothPanToPointAnimationFrame, wheelZoomAnimationFrame;
	var wheelToX, wheelToY, wheelToScale;
	var pinchDistance, pinchDistanceStart, posX_min, posY_min, posX_max, posY_max, scaleX_max, scaleY_max, scaleX_min, scaleY_min, scaleMin;
	var inputX = 0;
	var inputY = 0;
	var inputXlast = 0;
	var inputYlast = 0;
	var mylatesttap;

	_this.selector = selector;
	_this.position = {x:0,y:0};
	_this.isDragging = false;
	_this.isTouching = false;
	_this.isPinching = false;
	_this.isFollowing = false;
	_this.isTransitioning = false;
	_this.preventInput = false;

	var parentWidth = parent.offsetWidth;
	var parentHeight = parent.offsetHeight;

	if(debug){
		var inputMarker = document.createElement("div");
		inputMarker.classList.add('panzoom-marker','fixed-scale');
		inputMarker.style.cssText = "position:absolute;top:0;left:0;background:cyan;width:10px;height:10px;margin:-5px 0 0 -5px;border-radius:100%;z-index:2;";
		parent.appendChild(inputMarker);
	}
	//set required css
	// parent.style.overflow = 'hidden'; // set this in css, glitch otherwise
	// parent.style.touchAction = 'none'; //set this in css to avoid any dragging before js loads
	// parent.style.userSelect = 'none'; //set this in css to avoid any dragging before js loads
	element.style.transformOrigin = "0 0";

	//register events
	// desktop
	parent.addEventListener("pointerdown", handlePointerDown);
	// parent.addEventListener("pointermove", handlePointerMove);
	document.addEventListener("pointerup", handlePointerUp);
	parent.addEventListener("wheel", handleWheel);
	// mobile
	parent.addEventListener("touchstart", handleTouchDown, false);
	// parent.addEventListener("touchmove", handleTouchMove);
	document.addEventListener("touchend", handleTouchUp, false);

	//calculate pan offset needed when zooming so it scales from input as origin
	//TODO: look ahead for max scale, it craps out otherwise.
	function getZoomPanOffset(deltaScale){
    // var {x, y, width, height} = element.getBoundingClientRect();
    var r = element.getBoundingClientRect();
    var x = r.x;
    var y = r.y;
    var width = r.width;
    var height = r.height;
    // console.log(window.scrollY);
    y = y + window.scrollY; //needed if scrolled down page for some reason!!!??? TODO: is this right here - EDIT: nope
    var offsetX = (inputX-x)/width*element.offsetWidth;
    var offsetY = (inputY-y)/height*element.offsetHeight;
		var toX = deltaScale*(-offsetX);
		var toY = deltaScale*(-offsetY);
		return {x:toX,y:toY};
	}

	function calcToElementRect(target){
		var r = element.getBoundingClientRect();
		var x = r.x;
		var y = r.y;
		var width = r.width;
		var height = r.height;
		// var {x:tx, y:ty, width:twidth, height:theight} = target.getBoundingClientRect();
		var tr = target.getBoundingClientRect();
		var tx = tr.x;
		var ty = tr.y;
		var twidth = tr.width;
		var theight = tr.height;
		var toX = (tx - x)/_this.scale;
		var toY = (ty - y)/_this.scale;
		return {x:toX,y:toY,width:twidth/_this.scale,height:theight/_this.scale};
	}
	
	//=======================================================================================
	// pointer events run on desktop and mobile. touch runs after mobile only.
	//=======================================================================================

	//=======================================================================================
	// Down 
	//=======================================================================================
	function handlePointerDown(event){
		if(restrictClickToParent==true && event.target!=parent) return; //prevent selecting any children if overflow not hidden
	  if(_this.preventInput) return false;
		document.addEventListener("pointermove", handlePointerMove);
		// console.log('PointerDown');
	  if(doubleClickZoom) checkIsDoubleClick(event);
	  _this.isDragging = true;
    inputX = inputXlast = event.pageX;
    inputY = inputYlast = event.pageY;
		cancelAnimationFrame(inertiaAnimationFrame);
		inertiaAnimationFrame = requestAnimationFrame(inertiaLoop);
	}
	function handleTouchDown(event){
	  if(_this.preventInput) return false;
	  if(preventSingleTouchDragging && event.touches.length == 1) { // for 2 finder only - 1 finger passthrough
	  	_this.isDragging = false;
	  }
		if(event.touches.length==1) document.addEventListener("touchmove", handleTouchMove);
	  if(preventSingleTouchDragging) parent.classList.remove('requiretwofingerdragging');
		// console.log('TouchDown');
	  if (event.touches.length == 2) {
	  	_this.isDragging = true;
	    _this.isPinching = true;
	    pinchDistance = pinchDistanceStart = Math.hypot( event.touches[0].pageX-event.touches[1].pageX,event.touches[0].pageY-event.touches[1].pageY);
	    inputX = inputXlast = event.touches[0].pageX + (event.touches[1].pageX - event.touches[0].pageX)/2;
	    inputY = inputYlast = event.touches[0].pageY + (event.touches[1].pageY - event.touches[0].pageY)/2;
	  }
	}
	function checkIsDoubleClick(event){
		var now = new Date().getTime();
		var timesince = now - mylatesttap;
		var distanceFromLastTap = Math.hypot( inputX - event.pageX,inputY - event.pageY);
		mylatesttap = new Date().getTime();
		if((timesince < doubleClickTime) && (timesince > 0) && (distanceFromLastTap < 20)){
			// double click
	 		_this.triggerEvent('doubleClick',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});
		  var target = event.target;
		  if(target == element){
			  _this.smoothPanToPointAbs(event.pageX,event.pageY,_this.scale + (2*_this.scale));
		  } else {
		  	//clicking on a child element zoom to the center of that
		  	if(target.classList.contains('panzoom_double_click_zoom') || doubleClickZoomFitChildren){
			  	var rect = calcToElementRect(target);
			  	_this.smoothFitRect(rect);
	 				_this.triggerEvent('doubleClickChild',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});
		  	} else {
		  		var zoomAmnt = event.button==2? -0.6:2;
			  	_this.smoothPanToPointAbs(event.pageX,event.pageY,_this.scale + (zoomAmnt*_this.scale));
		  	}
		  }
		}
	}

	//=======================================================================================
	// Move
	//=======================================================================================
	function handlePointerMove(event){
	  if(!_this.isDragging || _this.preventInput) return false;
		// console.log('PointerMove');
	  if(!_this.isPinching) {
	    inputX = event.pageX;
	    inputY = event.pageY;
	    _this.position = {x:_this.position.x+(inputX-inputXlast),y:_this.position.y+(inputY-inputYlast)};
	 		_this.triggerEvent('panning',{inputX:inputX,inputY:inputY,inputXlast:inputXlast,inputYlast:inputYlast,panX:_this.position.x,panY:_this.position.y});
	 		_this.triggerEvent('update',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});
	  }
	  inputXlast = inputX;
	  inputYlast = inputY;
	  draw('pointerMove');
	}
	function handleTouchMove(event){
			// console.log('TouchMove');
			if((parent.contains(event.target) || event.target===parent) && preventSingleTouchDragging==false) event.preventDefault();
	  	if(!_this.isDragging || _this.preventInput) return false;
	  	
	    if(_this.isPinching) {
	    	if(dragWhilePinchZooming){
		    	var p1x = event.touches[0].pageX;
		    	var p2x = event.touches[1].pageX;
		    	var p1y = event.touches[0].pageY;
		    	var p2y = event.touches[1].pageY;
		    	var mid = {x:(p1x + p2x) / 2, y:(p1y + p2y) / 2};
		    	inputX = mid.x;
		    	inputY = mid.y;
		    	_this.position = {x:_this.position.x+(inputX-inputXlast),y:_this.position.y+(inputY-inputYlast)};
	 				_this.triggerEvent('pinchZoom',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});
	    	}
	      pinchDistance = Math.hypot( event.touches[0].pageX-event.touches[1].pageX,event.touches[0].pageY-event.touches[1].pageY);
	      var deltaScale = ((pinchDistance - pinchDistanceStart)/300);
	      pinchDistanceStart = pinchDistance;
	  		deltaScale *= _this.scale;//uniform scaling relative to scale
	      _this.panToPoint(false,false,_this.scale + deltaScale);
	    }
	 		_this.triggerEvent('update',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});
	}

	//=======================================================================================
	// Up
	//=======================================================================================
	function handlePointerUp(event){
		// console.log('PointerUp');
	  _this.isDragging = false;
		document.removeEventListener("pointermove", handlePointerMove);
	 	_this.triggerEvent('endInteraction',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});
	}
	function handleTouchUp(event){
		// console.log('TouchUp');
	  if(preventSingleTouchDragging) parent.classList.add('requiretwofingerdragging');
		if(event.touches.length<2){
		  _this.isPinching = false;
		}
		if(event.touches.length==0){
		  _this.isTouching = false;
			document.addEventListener("touchmove", handleTouchMove);
		}
	}

	//=======================================================================================
	// Mouse Wheel
	//=======================================================================================
	function handleWheel(event){
		//check if shift is pressed
		// console.log('cant zoom without shift');
		if(restrictClickToParent==true && event.target!=parent) return; //prevent selecting any children if overflow not hidden
		if(_this.useShiftKey) if(!event.shiftKey) {
			throttle(function() { _this.triggerEvent('useShiftKey',null); }, options.useShiftKeyCallbackThrottle);
			return false;
		}
		event.preventDefault();
		//check if dragging or prevent input is on
	  if(_this.isDragging || _this.preventInput) return false;
	  var wheelDelta =  (event.wheelDelta*wheel_step/500);
	  inputX = event.pageX;
	  inputY = event.pageY;
	  wheelDelta *= _this.scale;
	  wheelToScale = _this.scale + wheelDelta;
	  // bounds detection
    if((scaleMin && wheelDelta<0 && wheelToScale<=scaleMin) || (scaleMax && wheelDelta>0 && wheelToScale>=scaleMax)) {
    	var limitScale = wheelDelta < 0 ? scaleMin : scaleMax;
  	  var offset = getZoomPanOffset(limitScale - _this.scale);//find out remainder needed to zoom to the minScale
  	  wheelToX = _this.position.x + offset.x;
  	  wheelToY = _this.position.y + offset.y;
    	wheelToScale = limitScale;
    	// return;
    } else {

		  var offset = getZoomPanOffset(wheelDelta);
		  wheelToX = _this.position.x + offset.x;
		  wheelToY = _this.position.y + offset.y;
    }

	 	_this.triggerEvent('wheelZoom',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});

	  // disable smooth with this....
	  // _this.position.x = wheelToX;
	  // _this.position.y = wheelToY;
  	// scale = wheelToScale;

	  //smooth lerp to the value (disable this and enable above to disable smooth lerp zoom)
	  if(!wheelZoomAnimationFrame) requestAnimationFrame(updateWheelZoom);
	}
  function updateWheelZoom(){
		wheelZoomAnimationFrame = requestAnimationFrame(updateWheelZoom);
  	_this.position.x += (wheelToX - _this.position.x) * 0.2;
  	_this.position.y += (wheelToY - _this.position.y) * 0.2;
  	_this.scale += (wheelToScale - _this.scale) * 0.2;
	 	_this.triggerEvent('update',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});
  	//stop when close enough to completion (never reaches 0, prob should do this better)
    if (Math.abs(wheelToScale - _this.scale) < 0.001 || _this.isDragging) {
    	cancelAnimationFrame(wheelZoomAnimationFrame);
    	wheelZoomAnimationFrame = false;
    	if(_this.isDragging) draw();//needed cause pointerdown stops this cycle but doesn't draw
	 		_this.triggerEvent('endInteraction',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});
    }
    draw('wheelZoom');
  }




	//=======================================================================================
	// Draw
	//=======================================================================================
	function draw(what){

		// console.log('drawing',what);
	  setBounds(); // calculate the bounds
	  element.style.transform = 'translate('+_this.position.x+'px,'+_this.position.y+'px) scale('+_this.scale+')';
	  // element.style.transform = 'translate3d('+_this.position.x+'px,'+_this.position.y+'px,0px) scale('+_this.scale+')';


	  // keep fixed-scale children fixed scale.
	  for (var i = 0; i < fixedScaleChildren.length; i++) {
	  	if(fixedScaleChildren[i].classList.contains('fixed-scale')){
	  		var childrenScale = 1/_this.scale;
	  		if(_this.scale < fixedScaleMin) childrenScale = 1/fixedScaleMin;
	  		if(_this.scale > fixedScaleMax) childrenScale = 1/fixedScaleMax;
	  		fixedScaleChildren[i].style.transform = 'scale('+childrenScale+')';
	  	}
	  }

		if(debug){
			inputMarker.style.left = inputX + 'px';
			inputMarker.style.top = inputY + 'px';
		}

	  //debug
	  // var crosshair_input = document.getElementById('crosshair_input');
	  // crosshair_input.style.left = inputX + 'px';
	  // crosshair_input.style.top = inputY + 'px';

	  // var crosshair_pan = document.getElementById('crosshair_pan');
	  // crosshair_pan.style.left = _this.position.x + 'px';
	  // crosshair_pan.style.top = _this.position.y + 'px';

	  // var crosshair_pan = document.getElementById('crosshair_center');
	  // crosshair_pan.style.left = parent.offsetLeft + parent.offsetWidth/2 + 'px';
	  // crosshair_pan.style.top = parent.offsetTop + parent.offsetHeight/2 + 'px';
	}




	//=======================================================================================
	//=======================================================================================
	// 
	// Exposed Functions
	// 
	//=======================================================================================
	//=======================================================================================

	// helper functions
	this.rectPadding = function(rect,padding) {
		return {x:rect.x-padding,y:rect.y-padding,width:rect.width+(padding*2),height:rect.height+(padding*2)};
	}
	this.getDistanceTo = function(toX,toY) {
		// get center point
	  var pr = parent.getBoundingClientRect();
		var cx = ((pr.width / 2) - _this.position.x)/_this.scale;
		var cy = ((pr.height / 2) - _this.position.y)/_this.scale;
		// if toX/Y not set, set same as center point
		var tx = toX ? toX : cx;
		var ty = toY ? toY : cy;
		var relDist = Math.hypot(tx-cx,ty-cy);
		// console.log('relative on map distance',relDist);
		var absDist = relDist * _this.scale;
		// console.log('absolute screen distance',relDist);
		return {"relative":relDist,"absolute":absDist};
	}


	//=======================================================================================
	// Pan To X Y  POSITIONS ARE RELATIVE TO THE ELEMENT!!!!
	//=======================================================================================
	this.panToPoint = function(toX,toY,toScale) {
		if(!toScale) toScale = _this.scale;
	  if(toScale>maxScale) toScale = maxScale;
		var deltaScale = toScale - _this.scale;
		//shouldnt be here? - this is needed for pinch zooming :-/
 		// limit
		if((scaleMin && deltaScale<0 && _this.scale<=scaleMin)) {
			_this.scale = scaleMin;
			return;
		}
		if((scaleMax && deltaScale>0 && _this.scale>=scaleMax)) {
			_this.scale = scaleMax;
			return;
		}
		//fix center
		if(!_this.isPinching){
			inputX = (parent.getBoundingClientRect().left + parent.offsetWidth/2);
			inputY = (parent.getBoundingClientRect().top + parent.offsetHeight/2);
		}
		_this.scale = toScale;
		var offset = getZoomPanOffset(deltaScale);
		_this.position.x += toX ? ((parent.offsetWidth/2) - (toX * _this.scale)) - _this.position.x: offset.x;
		_this.position.y += toY ? ((parent.offsetHeight/2) - (toY * _this.scale)) - _this.position.y: offset.y;

 		_this.triggerEvent('update',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});

		draw('panToPoint');
	}
	this.panToPointAbs = function(pageX,pageY,toScale) {
		// var {x, y, width, height} = element.getBoundingClientRect();
		var r = element.getBoundingClientRect();
		var x = r.x;
		var y = r.y;
		var width = r.width;
		var height = r.height;

		pageX = ((pageX - x) / _this.scale);
		pageY = ((pageY - y) / _this.scale);
		_this.panToPoint(pageX,pageY,toScale);
		// draw('panToPointAbs');
	}

	//=======================================================================================
	// Pan to Element
	//=======================================================================================
	this.panToElement = function(element,toScale) {
	  var toX = element.offsetLeft + (element.offsetWidth/2);
	  var toY = element.offsetTop + (element.offsetHeight/2);
	  _this.panToPoint(toX,toY,toScale);
	}

	//=======================================================================================
	// Pan by - move a distance
	//=======================================================================================
	this.panBy = function(x,y){
		// make focus center point
		// _this.position.x += x;
		// _this.position.y += y;
 		// _this.triggerEvent('update',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});
		// draw('panBy');

		var pr = parent.getBoundingClientRect();
		var cx = ((pr.width / 2) - _this.position.x)/_this.scale;
		var cy = ((pr.height / 2) - _this.position.y)/_this.scale;
		var toX = cx + (x/_this.scale);
		var toY = cy + (y/_this.scale);
	  _this.panToPoint(toX,toY,false);

	};

	//=======================================================================================
	// Zoom by - incremental zooming
	//=======================================================================================
	this.zoomBy = function(increment){
		// make focus center point
		inputX = parent.offsetLeft + parent.offsetWidth/2;
		inputY = parent.offsetTop + parent.offsetHeight/2;
		// increment *= _this.scale;
		// _this.panToPoint(false,false,_this.scale + increment);
		var toScale = _this.scale + (increment * _this.scale);
		if(increment>0) toScale = toScale + (increment * _this.scale);
		_this.panToPoint(false,false,toScale);
	};

	//=======================================================================================
	// Center (in parent)
	//=======================================================================================
	this.center = function() {
	  _this.panToPoint(element.offsetWidth/2,element.offsetHeight/2);
		// draw('center');
	}

	//=======================================================================================
	// Fit (in parent)
	//=======================================================================================
	this.fit = function() {
	  var scaleX = (parent.offsetWidth/element.offsetWidth);
	  var scaleY = (parent.offsetHeight/element.offsetHeight);
	  var sc = (bound=='cover') ? Math.max(scaleX,scaleY) : Math.min(scaleX,scaleY);
	  _this.panToPoint(element.offsetWidth/2,element.offsetHeight/2,sc);
	}

	//=======================================================================================
	// Fit Cover (in parent)
	//=======================================================================================
	this.fitCover = function() {
		if(bound=='contain') console.warn('panzoom: \'contain\' bound mode doesn\'t support fitCover'); return;
	  var scaleX = (parent.offsetWidth/element.offsetWidth);
	  var scaleY = (parent.offsetHeight/element.offsetHeight);
	  var sc = Math.max(scaleX,scaleY);
	  _this.panToPoint(element.offsetWidth/2,element.offsetHeight/2,sc);
	}

	//=======================================================================================
	// Fit Rect
	//=======================================================================================
	this.fitRect = function(rect,padding) {
		if(typeof padding=='undefined') padding = 0;
		if(typeof padding=='number') padding = {top:padding,bottom:padding,left:padding,right:padding};
		if(typeof padding=='object') padding = padding;
	  var scaleX = ((parent.offsetWidth-(padding.left+padding.right))/element.offsetWidth) * ((element.offsetWidth)/rect.width);
	  var scaleY = ((parent.offsetHeight-(padding.top+padding.bottom))/element.offsetHeight) * ((element.offsetHeight)/rect.height);
	  _this.scale = Math.min(scaleX,scaleY);
	  _this.panToPoint(rect.x + (rect.width/2) - ((padding.left-padding.right)/2)/scaleX, rect.y + (rect.height/2) - ((padding.top-padding.bottom)/2)/scaleY, _this.scale);
	}

	//=======================================================================================
	// Fit Element
	//=======================================================================================
	this.fitElement = function(element,padding) {
		// if(typeof padding!=='undefined') rect = rectPadding(rect,padding);
	  var rect = calcToElementRect(element);
	  _this.fitRect(rect,padding);
	}

	//=======================================================================================
	// Cancel any dragging and user input
	//=======================================================================================
	this.disableInput = function(){
		_this.preventInput = true;
	  _this.isDragging = false;
	  _this.isTouching = false;
	  _this.isPinching = false;
	}
	this.enableInput = function(){
		_this.preventInput = false;
	}


	//=======================================================================================
	// update .fixed-scale children - e.g if dynamically added any elements.
	//=======================================================================================
	this.updateFixedScaleChildren = function(){
		fixedScaleChildren = element.querySelectorAll('.fixed-scale');
		draw();
		// fixedScaleChildren = element.querySelectorAll("[class*='fixed-scale']");
	}









	//=======================================================================================
	// Smooth Pan To X Y
	// pans so the X,Y point (relative to top left of the element) is centred in view
	//=======================================================================================

	function easeLinear (t, b, c, d) {
    return c * t / d + b;
	}
	function easeInQuad (t, b, c, d) {
	    return c * (t /= d) * t + b;
	}
	function easeOutQuad (t, b, c, d) {
	    return -c * (t /= d) * (t - 2) + b;
	}
	function easeInOutQuad (t, b, c, d) {
	    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
	    return -c / 2 * ((--t) * (t - 2) - 1) + b;
	}
	function easeInSine (t, b, c, d) {
	    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	}
	function easeOutSine (t, b, c, d) {
	    return c * Math.sin(t / d * (Math.PI / 2)) + b;
	}
	function easeInOutSine (t, b, c, d) {
	    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	}
	function easeInExpo (t, b, c, d) {
	    return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
	}
	function easeOutExpo (t, b, c, d) {
	    return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
	}
	function easeInOutExpo (t, b, c, d) {
	    if (t == 0) return b;
	    if (t == d) return b + c;
	    if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
	    return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	}
	function easeInCirc (t, b, c, d) {
	    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	}
	function easeOutCirc (t, b, c, d) {
	    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	}
	function easeInOutCirc (t, b, c, d) {
	    if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
	    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	}
	function easeInCubic (t, b, c, d) {
	    return c * (t /= d) * t * t + b;
	}
	function easeOutCubic (t, b, c, d) {
	    return c * ((t = t / d - 1) * t * t + 1) + b;
	}
	function easeInOutCubic (t, b, c, d) {
	    if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
	    return c / 2 * ((t -= 2) * t * t + 2) + b;
	}
	function easeInQuart (t, b, c, d) {
	    return c * (t /= d) * t * t * t + b;
	}
	function easeOutQuart (t, b, c, d) {
	    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	}
	function easeInOutQuart (t, b, c, d) {
	    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	}
	function easeInQuint (t, b, c, d) {
	    return c * (t /= d) * t * t * t * t + b;
	}
	function easeOutQuint (t, b, c, d) {
	    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	}
	function easeInOutQuint (t, b, c, d) {
	    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
	    return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	}



	this.smoothPanToPoint = function(toX,toY,toScale,duration,callback) {
		_this.isTransitioning = true; parent.classList.add('is-transitioning');
		if(!toScale) toScale = _this.scale;
		if(!duration) duration = transitionDuration;
		_this.disableInput();
	  var fromX = _this.position.x;
	  var fromY = _this.position.y;
	  var fromScale = _this.scale;
	  if(toScale>maxScale) toScale = maxScale;
	  var deltaScale = toScale - _this.scale;
	  // inputX = parent.offsetLeft + parent.offsetWidth/2;
	  // inputY = parent.offsetTop + parent.offsetHeight/2;
	  //fix center

	  var pr = parent.getBoundingClientRect();
	  inputX = (pr.left + parent.offsetWidth/2) + window.scrollX;
	  inputY = (pr.top + parent.offsetHeight/2) + window.scrollY;

	  var offset = getZoomPanOffset(deltaScale);
	  var toXt = toX ? ((parent.offsetWidth/2) - (toX * toScale)) : _this.position.x + offset.x;
	  var toYt = toY ? ((parent.offsetHeight/2) - (toY * toScale)) : _this.position.y + offset.y;
	  
	  // get distance
	  var dist = _this.getDistanceTo(toX,toY);
	  var d = dist.absolute * (1 + deltaScale/100);
		// console.log('deltaScaleScaled',(deltaScale/toScale));
		console.log('deltaScale',(deltaScale/toScale));
		// console.log('deltaScale',deltaScale);
		// console.log('d',(Math.abs(deltaScale/_this.scale))*500);

	  var start = new Date().getTime();
	  // var timer = setInterval(function() {
	  // }, 1000 / fps);
	  function updateSmoothPanToPoint(){
	  	smoothPanToPointAnimationFrame = requestAnimationFrame(updateSmoothPanToPoint);
	    var time = new Date().getTime() - start;
	    //limits
	    if((scaleMin && deltaScale<0 && _this.scale<=scaleMin)) {
	    	_this.scale = scaleMin;
	    	stopSmoothPanToPoint(); // prob don't need these now, we're looking ahead for max/min scale now
	    	return;
	    }
	    if((scaleMax && deltaScale>0 && _this.scale>=scaleMax)) {
	    	_this.scale = scaleMax;
	    	stopSmoothPanToPoint(); // prob don't need these now, we're looking ahead for max/min scale now
	    	return;
	    }

	    //update
	    _this.scale = easeInOutSine(time, fromScale, toScale - fromScale, duration);
	    if(!_this.isFollowing) _this.position.x += easeInOutSine(time, fromX, toXt - fromX, duration) - _this.position.x; //_this.preventInput hack so it doesnt pan when in follow mode.
	    if(!_this.isFollowing) _this.position.y += easeInOutSine(time, fromY, toYt - fromY, duration) - _this.position.y;

	    //draw
	 		_this.triggerEvent('update',{scale:_this.scale,panX:_this.position.x,panY:_this.position.y});

	    //reached end
    	// console.log('end',Math.abs(Math.max(_this.position.x - toX, _this.position.y - toY)));
	    if (time >= duration) {
	    	stopSmoothPanToPoint();
	    	if(!_this.isFollowing) {
	    		_this.position.x = toXt;
	    		_this.position.y = toYt;
	    		_this.scale = toScale;
	    	}
				draw('updateSmoothPanToPoint');
	    	return;
	    }

			draw('updateSmoothPanToPoint');
	  }
	  requestAnimationFrame(updateSmoothPanToPoint);

	  function stopSmoothPanToPoint(){
    	if(!_this.isFollowing) _this.enableInput();
			_this.isTransitioning = false; parent.classList.remove('is-transitioning');
			cancelAnimationFrame(smoothPanToPointAnimationFrame);
    	if(callback) callback();
			_this.triggerEvent('smoothPanToPointEnd',{panX:_this.position.x,panY:_this.position.y});	  	
	  }
	}
	this.smoothPanToPointAbs = function(pageX,pageY,toScale,duration,callback) {
		// var {x, y, width, height} = element.getBoundingClientRect();
		var r = element.getBoundingClientRect();
		var x = r.x;
		var y = r.y;
		var width = r.width;
		var height = r.height;

		pageX = ((pageX - x) / _this.scale);
		pageY = ((pageY - y) / _this.scale);
		_this.smoothPanToPoint(pageX,pageY,toScale,duration,callback);
	}

	//=======================================================================================
	// Smooth Pan to Element
	//=======================================================================================
	this.smoothPanToElement = function(element,toScale,duration,callback) {
	  var toX = element.offsetLeft + (element.offsetWidth/2);
	  var toY = element.offsetTop + (element.offsetHeight/2);
	  _this.smoothPanToPoint(toX,toY,toScale,duration,callback);
	}

	//=======================================================================================
	// Smooth Pan by - move a distance
	//=======================================================================================
	this.smoothPanBy = function(x,y,duration,callback){
		var pr = parent.getBoundingClientRect();
		var cx = ((pr.width / 2) - _this.position.x)/_this.scale;
		var cy = ((pr.height / 2) - _this.position.y)/_this.scale;
		var toX = cx + (x/_this.scale);
		var toY = cy + (y/_this.scale);
	  _this.smoothPanToPoint(toX,toY,false,duration,callback);
	};

	//=======================================================================================
	// Smooth Zoom by - incremental zooming
	//=======================================================================================
	this.smoothZoomBy = function(increment,duration,callback){
		// make focus center point (not required any more?)
		inputX = parent.offsetLeft + parent.offsetWidth/2;
		inputY = parent.offsetTop + parent.offsetHeight/2;
		// increment *= _this.scale;
		// _this.smoothPanToPoint(false,false,_this.scale + increment,duration,callback);
		var toScale = _this.scale + (increment * _this.scale);
		if(increment>0) toScale = toScale + (increment * _this.scale);
		_this.smoothPanToPoint(false,false,toScale,duration,callback);
	};

	//=======================================================================================
	// Smooth Center
	//=======================================================================================
	this.smoothCenter = function(duration,callback) {
		_this.smoothPanToPoint(element.offsetWidth/2,element.offsetHeight/2,false,duration,callback);
	};

	//=======================================================================================
	// Smooth Fit
	//=======================================================================================
	this.smoothFit = function(duration,callback) {
	  var scaleX = (parent.offsetWidth/element.offsetWidth);
	  var scaleY = (parent.offsetHeight/element.offsetHeight);
	  var sc = (bound=='cover') ? Math.max(scaleX,scaleY) : Math.min(scaleX,scaleY);
		_this.smoothPanToPoint(element.offsetWidth/2,element.offsetHeight/2,sc,duration,callback);
	};

	//=======================================================================================
	// Smooth Fit Cover
	//=======================================================================================
	this.smoothFitCover = function(duration,callback) {
	  var scaleX = (parent.offsetWidth/element.offsetWidth);
	  var scaleY = (parent.offsetHeight/element.offsetHeight);
	  var sc = Math.max(scaleX,scaleY);
		_this.smoothPanToPoint(element.offsetWidth/2,element.offsetHeight/2,sc,duration,callback);
	};

	//=======================================================================================
	// Smooth FitRect
	//=======================================================================================
	this.smoothFitRect = function(rect,padding,duration,callback) {
  	if(typeof padding=='undefined') padding = 0;
  	if(typeof padding=='number') padding = {top:padding,bottom:padding,left:padding,right:padding};
  	if(typeof padding=='object') padding = padding;
    var scaleX = ((parent.offsetWidth-(padding.left+padding.right))/element.offsetWidth) * ((element.offsetWidth)/rect.width);
    var scaleY = ((parent.offsetHeight-(padding.top+padding.bottom))/element.offsetHeight) * ((element.offsetHeight)/rect.height);
    toScale = Math.min(scaleX,scaleY);
	  _this.smoothPanToPoint(rect.x + (rect.width/2) - ((padding.left-padding.right)/2)/scaleX, rect.y + (rect.height/2) - ((padding.top-padding.bottom)/2)/scaleY, toScale, duration, callback);
	};

	//=======================================================================================
	// Smooth Fit Element
	//=======================================================================================
	this.smoothFitElement = function(element,padding,duration,callback) {
	  var rect = calcToElementRect(element);
	  _this.smoothFitRect(rect,padding,duration,callback);
	}

	//=======================================================================================
	// Follow
	//=======================================================================================
	this.smoothFollow = function(followElement,toScale,coeff) {
		_this.smoothFollowStop();
		_this.isFollowing = true; parent.classList.add('is-following');
		_this.disableInput();
		if(coeff==undefined) coeff = 0;
		var start = new Date().getTime();

		//global to local I think?
		// const {x, y, width, height} = element.getBoundingClientRect();
		var r = element.getBoundingClientRect();
		var x = r.x;
		var y = r.y;
		var width = r.width;
		var height = r.height;

		var fromX =  (((parent.offsetLeft + parent.offsetWidth/2) - x) / _this.scale) ;
		var fromY = (((parent.offsetTop + parent.offsetHeight/2) - y) / _this.scale) ;

		var laggedPosition = {x:fromX,y:fromY};
		if(toScale) _this.smoothPanToPoint(false,false,toScale,1000);

		// smoothFollowTimer = setInterval(function() {
		// }, 1000 / fps);
		
		function updateFollow(){
			smoothFollowAnimationFrame = requestAnimationFrame(updateFollow);
			// const {x, y, width, height} = followElement.getBoundingClientRect(); 
			var r = followElement.getBoundingClientRect();
			var x = r.x;
			var y = r.y;
			var width = r.width;
			var height = r.height;

			// const {x:eX, y:eY, width:eWidth, height:eHeight} = element.getBoundingClientRect(); 
			var er = element.getBoundingClientRect();
			var eX = er.x;
			var eY = er.y;
			var eWidth = er.width;
			var eHeight = er.height;

			var toX = (x+width/2 - eX)/_this.scale;
			var toY = (y+height/2 - eY)/_this.scale;
			// set focus on object so we can zoom at any time.
			inputX = x + width/2;
			inputY = y + height/2;
			//smooth it out
			laggedPosition.x += (toX - laggedPosition.x)*(1-coeff);
			laggedPosition.y += (toY - laggedPosition.y)*(1-coeff);
		  _this.panToPoint(laggedPosition.x,laggedPosition.y);
	    draw('updateFollow');
		}
		smoothFollowAnimationFrame = requestAnimationFrame(updateFollow);
	};

	this.smoothFollowStop = function() {
		_this.isFollowing = false; parent.classList.remove('is-following');
		_this.enableInput();
		cancelAnimationFrame(smoothFollowAnimationFrame);
		// clearInterval(smoothFollowTimer);
	}

	this.setBound = function(toBound){
		bound = toBound;
		_this.center();
		_this.fit();
	}
	

	//=======================================================================================
	// Bounds
	//=======================================================================================
	function setBounds(){
	  var elScaledWidth = element.offsetWidth*(_this.scale);
	  var elScaledHeight = element.offsetHeight*(_this.scale);
	  if(bound == 'contain') {
	    posX_min = 0; 
	    posY_min = 0; 
	    posX_max = parent.offsetWidth - elScaledWidth; 
	    posY_max = parent.offsetHeight - elScaledHeight;
	    scaleX_max = (parent.offsetWidth / element.offsetWidth);
	    scaleY_max = (parent.offsetHeight / element.offsetHeight);
	    //make sure max scale is most max
	    var max = Math.min(scaleX_max,scaleY_max);
	    scaleMax = maxScale ? Math.min(max,maxScale) : max;
	    // if(max>maxScale) scaleMax = max;
	    scaleMin = minScale;//no min scale, so use pref
	  }
	  else if(bound == 'cover') {
	    // posX_max = element.offsetWidth/2*(scale-1)-position.x;
	    // posY_max = element.offsetHeight/2*(scale-1)-position.y;
	    // posX_min = parent.offsetWidth-element.offsetWidth-element.offsetWidth/2*(scale-1)-position.x;
	    // posY_min = parent.offsetHeight-element.offsetHeight-element.offsetHeight/2*(scale-1)-position.y;
	    posX_min = parent.offsetWidth - elScaledWidth;
	    posY_min = parent.offsetHeight - elScaledHeight;
	    posX_max = 0;
	    posY_max = 0;
		  scaleX_min = (parent.offsetWidth / element.offsetWidth);
		  scaleY_min = (parent.offsetHeight / element.offsetHeight);
	    //make sure min scale is most min
	    var min = Math.max(scaleX_min,scaleY_min);
	    // if(min>minScale) scaleMin = min;
	    scaleMin = minScale ? Math.max(min,minScale) : min;
	    scaleMax = maxScale;//no max scale, so use pref




	    // if(elScaledHeight > parent.offsetHeight){
	    // 	posX_min = (parent.offsetWidth - elScaledWidth); 
	    // 	posY_min = (parent.offsetWidth - elScaledWidth); 
	    // 	posX_max = 0; 
	    // 	posY_max = 0;
	    // } else {
	    // 	posX_min = 0; 
	    // 	posY_min = 0; 
	    // 	posX_max = parent.offsetWidth - elScaledWidth; 
	    // 	posY_max = parent.offsetHeight - elScaledHeight;
	    // }





	    if(elScaledWidth > parent.offsetWidth){
	    	posX_min = (parent.offsetWidth - elScaledWidth); 
	    	posX_max = 0; 
	    } else {
	    	posX_min = 0; 
	    	posX_max = parent.offsetWidth - elScaledWidth; 
	    }

	    if(elScaledHeight > parent.offsetHeight){
	    	posY_min = (parent.offsetHeight - elScaledHeight); 
	    	posY_max = 0;
	    } else {
	    	posY_min = 0; 
	    	posY_max = parent.offsetHeight - elScaledHeight;
	    }



	    scaleMax = maxScale;
	    scaleMin = minScale;








	  }
	  else if(bound == 'inner') {
	    posX_min = -elScaledWidth + innerPadding; 
	    posY_min = -elScaledHeight + innerPadding; 
		  posX_max = parent.offsetWidth - innerPadding; 
		  posY_max = parent.offsetHeight - innerPadding;
	    scaleMin = minScale;//no min scale, so use pref
	    scaleMax = maxScale;//no max scale, so use pref
	  }
	  if(bound !== 'none') {
	  	//this actually sets position.x and position.y

	    _this.position.x = Math.min(Math.max(posX_min, _this.position.x), posX_max);    // Restrict
	    _this.position.y = Math.min(Math.max(posY_min, _this.position.y), posY_max);    // Restrict
	    //limit going large
	    // if(scale > scaleX_max) scale = scaleX_max;
	    // if(scale > scaleY_max) scale = scaleY_max;
	    // //limit going smaller
	    // if(scale < scaleX_min) scale = scaleX_min;
	    // if(scale < scaleY_min) scale = scaleY_min;
	    // if(scale < minScale) scale = minScale;//global options

	  }
    if(scaleMin && _this.scale < scaleMin) _this.scale = scaleMin;
    if(scaleMax && _this.scale > scaleMax) _this.scale = scaleMax;
	}


	//=======================================================================================
	// Inertia
	//=======================================================================================

	var inertiaPosition = { x:0, y:0, scale:0 };
	var inertiaPreviousPosition = { x: inertiaPosition.x, y: inertiaPosition.y, scale: inertiaPosition.scale };
	var inertiaVelocity = { x:0, y:0, scale:0 };
	var inertiaAnimationFrame;
	var previousPosition;
	
	function inertiaLoop() {
			if(_this.isTransitioning) return;
			inertiaAnimationFrame = requestAnimationFrame(inertiaLoop);
	    // if (_this.isPinching || _this.isFollowing) {
	    if (_this.isFollowing) {
				inertiaVelocity = { x: 0, y: 0, scale:0 };
			}
	    // if (_this.isDragging && !_this.isPinching || _this.isFollowing) {
	    if (_this.isDragging || _this.isFollowing ) {
	        inertiaPreviousPosition = inertiaPosition;
	        inertiaPosition = { x: _this.position.x, y: _this.position.y, scale: _this.scale };
	        inertiaVelocity.x = (inertiaPosition.x - inertiaPreviousPosition.x);
	        inertiaVelocity.y = (inertiaPosition.y - inertiaPreviousPosition.y);
	        inertiaVelocity.scale = (inertiaPosition.scale - inertiaPreviousPosition.scale);
	    		previousPosition = { x: _this.position.x, y: _this.position.y, scale: _this.scale };
	    } else {
	        _this.position.x += inertiaVelocity.x;
	        _this.position.y += inertiaVelocity.y;
	        _this.scale += inertiaVelocity.scale;
	        inertiaVelocity.x *= inertiaFriction;
	        inertiaVelocity.y *= inertiaFriction;
	        inertiaVelocity.scale *= scaleInertiaFriction;
	        // bounce at bound   
	        if (_this.position.x >= posX_max) {
	            inertiaVelocity.x *= -inertiaBounce;
	            inertiaPosition.x = posX_max;
	        }
	        if (_this.position.x <= posX_min) {
	            inertiaVelocity.x *= -inertiaBounce;
	            inertiaPosition.x = posX_min;
	        }
	        if (_this.position.y >= posY_max) {
	            inertiaVelocity.y *= -inertiaBounce;
	            inertiaPosition.y = posY_max;
	        }
	        if (_this.position.y <= posY_min) {
	            inertiaVelocity.y *= -inertiaBounce;
	            inertiaPosition.y = posY_min;
	        }
	        if (_this.scale < scaleMin || _this.scale > scaleMax) {
	            inertiaVelocity.x *= -inertiaBounce;
	            inertiaVelocity.y *= -inertiaBounce;
	            inertiaVelocity.scale *= -inertiaBounce;
	        		_this.position.x = previousPosition.x;
	        		_this.position.y = previousPosition.y;
	        		_this.scale = previousPosition.scale;
	        }

	    		previousPosition = { x: _this.position.x, y: _this.position.y, scale: _this.scale };
	    		
	        draw('inertia'); //----------------------this is the main update loop!!!!---------------------
	        if(Math.hypot(inertiaVelocity.x, inertiaVelocity.y)<0.01) {
	        	// console.log('inertiaVelocity',inertiaVelocity);
					  cancelAnimationFrame(inertiaAnimationFrame);
					  return;
	        }
	    }
	}
	// requestAnimationFrame(inertiaLoop);
	// setInterval(inertiaLoop,1000/fps);



	//=======================================================================================
	// Events
	// prob doing this wrong but it works!
	//=======================================================================================

	this.on = function(eventName,callback){
		element.addEventListener(eventName, function(event) {
		  callback(event);
		});
	}

	this.triggerEvent = function(eventName,detail){
		// console.log(eventName,detail);
		var myEvent = new CustomEvent(eventName, {'detail': detail});
		element.dispatchEvent(myEvent);
	}

	// setTimeout(function(){
 //    console.log('timeout triggering custom-event...');
	//   _this.triggerEvent('custom-event',{stuff:'whatnot'});
	//   _this.triggerEvent('custom-event',{stuff:'howdoyoudo'});
	// },2000);


	draw('init');


	//============================================================================================
	// Click modifier
	// this improves click handling so false click doesn't happen when clicked, dragged and let go
	//============================================================================================
	if(clickSelector){
		var panzoomClickStart = {x:0,y:0};
		var links = parent.querySelectorAll(clickSelector);
		links.forEach(function(element,index){
			element.addEventListener("mousedown", function(e){
			  panzoomClickStart = {x:e.clientX,y:e.clientY};
			}, false);
			element.addEventListener("click", function(e){
			  var distX = Math.abs(e.clientX-panzoomClickStart.x);
			  var distY = Math.abs(e.clientY-panzoomClickStart.y);
			  var dist = Math.max(distX,distY);
			  if(dist < 2) return true;
			  e.stopPropagation();
			  e.stopImmediatePropagation();
			  e.preventDefault();
			  // console.log('a');
			}, false);
		});
	}

	if(preventRightClick){
		parent.addEventListener('contextmenu', function(e) {
		    e.preventDefault();
		    return false;
		}, false);
	}


	//============================================================================================
	// resize handler
	// re-centers to the map when resized
	//============================================================================================

	// disabled for now - affecting custom parent resizing script


	// if(updatePositionOnResize){
	// 	var lastWidth = parent.offsetWidth;
	// 	var lastHeight = parent.offsetHeight;
	// 	function debounce(func, wait, immediate) {
	// 		var timeout;
	// 		return function() {
	// 			var context = this, args = arguments;
	// 			var later = function() {
	// 				timeout = null;
	// 				if (!immediate) func.apply(context, args);
	// 			};
	// 			var callNow = immediate && !timeout;
	// 			clearTimeout(timeout);
	// 			timeout = setTimeout(later, wait);
	// 			if (callNow) func.apply(context, args);
	// 		};
	// 	};
	// 	//debounced version if updatePositionOnResizeDebounce > 0
	// 	var updatePositionDebounced = debounce(function() {
	// 		updatePosition();
	// 	}, updatePositionOnResizeDebounce);
	// 	// update positions function
	// 	function updatePosition(){
	// 		var pr = parent.getBoundingClientRect();
	// 		var cx = lastWidth - pr.width;
	// 		var cy = lastHeight - pr.height;
	// 		if(cx==0&&cy==0) return;
	// 		_this.position.x -= ((cx/2));
	// 		_this.position.y -= ((cy/2));
	// 		draw();
	// 		lastWidth = pr.width;
	// 		lastHeight = pr.height;
	// 	}
	// 	// if debounce set > 0 use debounce, otherwise run per event for smoothness
	// 	if(updatePositionOnResizeDebounce){
	// 		window.addEventListener('resize', updatePositionDebounced);
	// 	} else {
	// 		window.addEventListener('resize', updatePosition);
	// 	}
	// }







	// parent.addEventListener("mousedown", function(e){
	//   e.target.panzoomClickStart = {x:e.clientX,y:e.clientY};
	// });
	// parent.addEventListener("click", function(e){
	//   e.stopPropagation();
	//   e.preventDefault();
	//   if(typeof e.target.panzoomClickStart == 'undefined') return;
	//   var distX = Math.abs(e.clientX-e.target.panzoomClickStart.x);
	//   var distY = Math.abs(e.clientY-e.target.panzoomClickStart.y);
	//   var dist = Math.max(distX,distY);
	//   if(dist > 2) return false;
	//   console.log('click');
	// });



	//------------
	return (this);
}